import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";
type Props = {};
const BinKudagharAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const { defaultValuestime } = getISTDate();

  const [toaster, setToaster] = useState(false);
  const initialRowData = {
    "activeClass": "",
    "all": true,
    "showExisting": true,
    "isSuccess": true,
    "message": "",
    "srno": 0,
    "eScarp": true,
    "eScarpPrevValue": "",
    "css": "string",
    "binLocID": 0,
    "binLocName": "",
    "binLocCode": "",
    "zoneID": 0,
    "areaID": 0,
    "rfid": "",
    "latitude": 0,
    "longitude": 0,
    "locationName": "",
    "locImage": "",
    "description": "",
    "createdBy": "",
    "updatedBy": "",
    "createdOn": defaultValuestime,
    "updatedOn": defaultValuestime,
    "areaWardMaster": {
      "activeClass": "",
      "all": true,
      "showExisting": true,
      "isSuccess": true,
      "message": "",
      "eScarp": true,
      "eScarpPrevValue": "",
      "css": "",
      "areaID": 0,
      "areaName": "",
      "wardNumber": "",
      "zoneID": 0,
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValuestime,
      "updatedOn": defaultValuestime,
      "zoneMaster": {
        "zoneID": 0,
        "zoneName": "",
        "zoneAbbrevation": "",
        "createdBy": "",
        "updatedBy": "",
        "createdOn": defaultValuestime,
        "updatedOn": defaultValuestime,
        "srno": 0,
        "checked": true
      },
      "srno": 0
    },
    "zoneMaster": {
      "zoneID": 0,
      "zoneName": "",
      "zoneAbbrevation": "",
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValuestime,
      "updatedOn": defaultValuestime,
      "srno": 0,
      "checked": true
    }

  };

  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();

  const [areaWardData, setAreaWardData] = useState([
    { id: -1, label: t("text.areaName"), wardNumber: -1, zoneName: "" },
  ]);
  const [zoneOption, setzoneOption] = useState([
    { value: -1, label: t("text.zoneID") },
  ]);


  useEffect(() => {
    getAreaWardData();
    getzoneData();
  }, []);


  const getAreaWardData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",
      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "date1": "2024-11-08T07:53:02.678Z",
      "date2": "2024-11-08T07:53:02.678Z",
      "date3": "2024-11-08T07:53:02.678Z",
      "date4": "2024-11-08T07:53:02.678Z",
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true

    };
    const response = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        id: data[index]["areaID"],
        label: data[index]["areaName"],
        wardNumber: data[index]["wardNumber"],
        zoneName: data[index]["zoneMaster"]["zoneName"]
      });
    }
    setAreaWardData(arr);
  }

  const getzoneData = async () => {
    const collectData = {
      "zoneID": -1,
      "user_ID": "",
    };
    const response = await api.post(`Zone/GetZonemaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["zoneName"],
        value: data[index]["zoneID"],
      });
    }
    setzoneOption(arr);
  };



  const formik = useFormik({
    initialValues: {
      "activeClass": "",
      "all": true,
      "showExisting": true,
      "isSuccess": true,
      "message": "",
      "srno": 0,
      "eScarp": true,
      "eScarpPrevValue": "",
      "css": "",
      "binLocID": 0,
      "binLocName": "",
      "binLocCode": "",
      "zoneID": 0,
      "areaID": 0,
      "rfid": "",
      "latitude": 0,
      "longitude": 0,
      "locationName": "",
      "locImage": "",
      "description": "",
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValuestime,
      "updatedOn": defaultValuestime,
      "areaWardMaster": {
        "activeClass": "",
        "all": true,
        "showExisting": true,
        "isSuccess": true,
        "message": "",
        "eScarp": true,
        "eScarpPrevValue": "",
        "css": "",
        "areaID": 0,
        "areaName": "",
        "wardNumber": "",
        "zoneID": 0,
        "createdBy": "",
        "updatedBy": "",
        "createdOn": defaultValuestime,
        "updatedOn": defaultValuestime,
        "zoneMaster": {
          "zoneID": 0,
          "zoneName": "",
          "zoneAbbrevation": "",
          "createdBy": "",
          "updatedBy": "",
          "createdOn": defaultValuestime,
          "updatedOn": defaultValuestime,
          "srno": 0,
          "checked": true
        },
        "srno": 0
      },
      "zoneMaster": {
        "zoneID": 0,
        "zoneName": "",
        "zoneAbbrevation": "",
        "createdBy": "",
        "updatedBy": "",
        "createdOn": defaultValuestime,
        "updatedOn": defaultValuestime,
        "srno": 0,
        "checked": true
      }
    },

    validationSchema: Yup.object({
      binLocName: Yup.string()
        .required("Bin Name is required"),
      binLocCode: Yup.string()
        .required("Bin Code is required"),
      rfid: Yup.string()
        .required("rfid is required"),
    }),

    onSubmit: async (values) => {
      try {
        const response = await api.post(`BinLocation/AddUpdateBinLocation`, values);

        if (response.data.status === 1) {
          setToaster(false);
          toast.success(response.data.message);
          navigate("/Admin/masters/stockbin");
        } else {
          setToaster(true);
          toast.error(response.data.message);
          navigate("/Admin/masters/stockbin");
        }

      } catch (error) {
        setToaster(true);
        toast.error("An error occurred while saving. Please try again.");
        console.error("API Error:", error);
      }
    },
  });
  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.AddBin")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={areaWardData}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue);
                    formik.setFieldValue("areaWardMaster.areaName", newValue?.label);
                    formik.setFieldValue("areaWardMaster.areaID", newValue?.id);
                    formik.setFieldValue("areaWardMaster.wardNumber", newValue?.wardNumber);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.EnterBinAreaName")} />}
                      name="areaWardMaster.areaName"
                      id="areaWardMaster.areaName"
                      placeholder={t("text.EnterBinAreaName")}
                      error={formik.touched.areaWardMaster?.areaName && Boolean(formik.errors.areaWardMaster?.areaName)}
                    />
                  )}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.EnterBinAreaName")}
                  value={formik.values.areaWardMaster.areaName}
                  onChangeText={(text: string) => formik.setFieldValue("areaWardMaster.areaName", text)}
                  required={true}
                  lang={lang}
                />
                 {formik.touched.areaWardMaster.areaName && formik.errors.areaWardMaster.areaName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.areaWardMaster.areaName}
                  </div>
                ) : null}
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.EnterBinWardNumber")}
                    />
                  }
                  disabled={true}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="areaWardMaster.wardNumber"
                  id="areaWardMaster.wardNumber"
                  value={formik.values.areaWardMaster.wardNumber}
                  placeholder={t("text.EnterBinWardNumber")}
                  onChange={formik.handleChange}
                />
                {/* {formik.touched.areaWardMaster.wardNumber && formik.errors.areaWardMaster.wardNumber ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.areaWardMaster.wardNumber}
                  </div>
                ) : null} */}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={zoneOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("zoneMaster.zoneName", newValue?.value.toString());
                    formik.setFieldValue("zoneMaster.zoneID", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.EnterZone")} />}
                      name="zoneMaster.zoneName"
                      id="zoneMaster.zoneName"
                      placeholder={t("text.EnterZone")}

                    />
                  )}
                />

              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.EnterBinName")}
                  value={formik.values.binLocName}
                  onChangeText={(text: string) => formik.setFieldValue("binLocName", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.binLocName && formik.errors.binLocName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.binLocName}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.EnterBinCode")} required={true} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="binLocCode"
                  id="binLocCode"
                  value={formik.values.binLocCode}
                  placeholder={t("text.EnterBinCode")}
                  onChange={formik.handleChange}
                />
                {formik.touched.binLocCode && formik.errors.binLocCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.binLocCode}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.EnterBinRFID")}
                  value={formik.values.rfid}
                  onChangeText={(text: string) => formik.setFieldValue("rfid", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.rfid && formik.errors.rfid ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.rfid}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <TranslateTextField
                  label={t("text.EnterBinDesc")}
                  value={formik.values.description}
                  onChangeText={(text: string) => formik.setFieldValue("description", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.description && formik.errors.description ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.description}
                  </div>
                ) : null}
              </Grid>


              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => { formik.resetForm(); console.log(areaWardData) }}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default BinKudagharAdd;